import { Component, OnInit } from '@angular/core';
import { UtilsService } from 'src/app/Services/utils.service';

@Component({
  selector: 'app-redirect',
  templateUrl: './redirect.component.html',
  styleUrls: ['./redirect.component.scss']
})
export class RedirectComponent implements OnInit {
  userType = localStorage.getItem('userType')
  constructor( private utils : UtilsService) { }

  ngOnInit() {
    switch(this.userType){
      case "od1":
        this.utils.redirect('/dashboard')
        break;
      case "od2":
        this.utils.redirect('/entity/dashboard');
        break;
      case "od3":
        this.utils.redirect('/entity/dashboard');
        break;
      case "od4":
        this.utils.redirect('/studentDashboard')
    }
  }
}
